// NotificationContext.js
import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState({ message: "", severity: "info" });

    const showNotification = (message, severity = "info") => {
        setOptions({ message, severity });
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={5000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity={options.severity} variant="filled">
                    {options.message}
                </Alert>
            </Snackbar>
        </NotificationContext.Provider>
    );
};
